export default {"src":"/_next/static/media/stripe-atlas-svb-partner.269c80a5.svg","height":46,"width":526};